// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0064a474","703":"be91b23d"}[chunkId] + ".chunk.js";
};